import { Fragment, memo, ReactElement } from 'react';
import { Form, Formik } from 'formik';
import { ResearchAct } from 'civil-status/view-models/research-category-form';
import * as yup from 'yup';
import { Accordion, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { AccordionDetails } from '@mui/material';
import { ResearchNotifications } from 'notifications-from-civil-status/view-models/notifications-list';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FormFilter from './form';

const validationSchema = yup.object({
  dateStart: yup.date().nullable().typeError('Data non valida'),
  dateEnd: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .when('dateStart', (dateStart, formvalidationSchema) =>
      dateStart && dateStart?.toString() !== 'Invalid Date'
        ? formvalidationSchema.min(
            dateStart,
            'La data deve essere maggiore o uguale della Data inizio'
          )
        : formvalidationSchema.nullable()
    ),
});

interface AccordionFilterProps {
  open?: boolean;
  withOperator?: boolean;
  setOpen: (value: boolean) => void;
  handleSubmitResearch: (values: ResearchAct) => void;
  initialValues?: ResearchAct;
  scope?: string;
  idCat?: string;
  isFromCivilStatus?: boolean;
  isNotCivilStatus?: boolean;
}

const AccordionFilterComponent = ({
  open,
  withOperator = false,
  setOpen,
  handleSubmitResearch,
  initialValues,
  scope,
  idCat,
  isFromCivilStatus,
  isNotCivilStatus,
}: AccordionFilterProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        key="form-filter"
        initialValues={
          initialValues ||
          ({
            code: '',
            dateEnd: null,
            dateStart: null,
            scope: scope || '',
            state: '',
            typeEvent: '',
          } as ResearchNotifications)
        }
        onSubmit={(values) => handleSubmitResearch(values)}
        validateOnMount
        validationSchema={validationSchema}
      >
        <Form>
          <Accordion
            expanded={open}
            onChange={() => {
              setOpen(!open);
            }}
          >
            <AccordionSummary
              aria-controls="filter-notifications-content"
              id="panel-filter-notifications-header"
              classes={{
                root: 'pmi-flex-row-reverse',
              }}
              expandIcon={<ExpandMore />}
            >
              <Typography>Filtri di ricerca</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormFilter
                idCat={idCat}
                scope={scope}
                withOperator={withOperator}
                isFromCivilStatus={isFromCivilStatus}
                isNotCivilStatus={isNotCivilStatus}
              />
            </AccordionDetails>
          </Accordion>
        </Form>
      </Formik>
    </Fragment>
  );
};

AccordionFilterComponent.displayName =
  'Research notifications - Filters component - AccordionFilter';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
